jQuery(function () {
    var scrollTop = 0;
    var dialogContainer = $('.test-account-dialog');
    var getMemberInfo = dialogContainer.find('.get-member-info');
    var feedback = dialogContainer.find('.feedback');
    $('.js-trigger-form-btn').on('click', function () {
        getMemberInfo.toggle();
        feedback.toggle();
    });
    $('.js-submit-feedback-btn').on('click', function (e) {
        e.preventDefault();
        var form = $('#test-account-feedback-form');
        var feedbackMessage = form.find('textarea').val();
        var url = $(this).attr('href');
        $.ajax({
            url: 'slut-pa-testperiod/sendfeedback',
            method: 'POST',
            data: { feedback: feedbackMessage }
        }).done(function () {
            showSuccessMessage();
            setTimeout(function () { window.location.href = url; }, 1500);
        }).fail(function () {
            showErrorMessage();
        });
    });
    function showErrorMessage() {
        var feedbackErrorMessage = $('.feedback-error-message');
        var feedbackSuccessMessage = $('.feedback-success-message');
        feedbackErrorMessage.removeClass('hidden');
        feedbackSuccessMessage.addClass('hidden');
    }
    function showSuccessMessage() {
        var feedbackErrorMessage = $('.feedback-error-message');
        var feedbackSuccessMessage = $('.feedback-success-message');
        feedbackErrorMessage.addClass('hidden');
        feedbackSuccessMessage.removeClass('hidden');
    }
    $(document).ready(function () {
        var testAccountEnd = $('body').find('.test-account-dialog');
        if (testAccountEnd.length > 0) {
            stopBodyScroll(true);
        }
    });
    function stopBodyScroll(stop) {
        var $body = $('body');
        if (stop) {
            scrollTop = $body.scrollTop();
            $body.addClass('prevent-mobile-scroll');
        }
        else {
            $body.removeClass('prevent-mobile-scroll');
            $body.scrollTop(scrollTop);
        }
    }
});
